export const TABLE_A_IMAGE = "/images/Table-A.png";
export const TABLE_B_IMAGE = "/images/Table-B.png";
